import { debounce } from 'lodash';
import { integrationGtag, stopVideoInterval } from './IntegrationGtag';
import { eventBus } from '~/modules/common/utils/eventBus';

export const videoEvents = (args) => {
  const { player } = args;
  const videoQualitySelector = player.qualityLevels ? player.qualityLevels() : null;
  let videoVolume = player.volume().toFixed(2);

  // Video player events for tracking
  player.on(
    'play',
    debounce(() => {
      stopVideoInterval();
      integrationGtag(player.currentTime() > 0 ? 'video_resumed' : 'video_start', { ...args });
    }, 100)
  );

  player.on('playing', function () {
    integrationGtag('video_playing', { data: { event_value: 10 }, ...args });
    eventBus.emit('video-playing', player.id_);
  });

  player.on('volumechange', () => {
    player.muted()
      ? integrationGtag('video_muted', { ...args })
      : videoVolume < player.volume()
      ? integrationGtag('volume_up', { ...args })
      : integrationGtag('volume_down', { ...args });
    videoVolume = player.volume();
  });

  player.on('seeking', () => {
    integrationGtag('video_seeked', { ...args });
  });

  player.on('fullscreenchange', () => {
    integrationGtag(player.isFullscreen() ? 'video_fullscreen_done' : 'video_fullscreen_undone', { ...args });
  });

  player.on('pause', function () {
    stopVideoInterval();
    if (Math.floor(player.currentTime()) !== Math.floor(player.duration())) {
      integrationGtag('video_paused', { ...args });
    }
  });

  player.on('ended', function () {
    stopVideoInterval();
    eventBus.emit('video-ended', player.id_);
    integrationGtag('video_complete', { ...args });
  });

  player.on('abort', () => {
    stopVideoInterval();
  });

  player.on('loadeddata', () => {
    stopVideoInterval();
  });

  videoQualitySelector?.on('change', () => {
    // when first press play button, change event of qualityselector was firing too.
    if (player.duration() && videoQualitySelector) {
      const quality = videoQualitySelector[videoQualitySelector.selectedIndex].height;
      integrationGtag('video_quality_selected', { data: { video_quality_option: quality }, ...args });
      stopVideoInterval();
    }
  });
};
